export default "__VITE_ASSET__FM5EeGyh__"